import styled, {ThemeProps} from 'styled-components';
import {Column} from './../../common/Layouts/Layouts';
import {Assign} from 'utility-types';
import {Theme} from '../../../../theme/types';
import {ButtonBase} from '../../../CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';

export interface WrapperDivRightProps {
  sticky?: boolean;
}

export interface OuterWrapperSectionProps {
  backgroundColor?: string;
}

export interface SelectRoomButtonProps {
  backgroundColor?: string;
}

export interface SimilarHotelBorderProps {
  currentHotel?: boolean;
}

export const WrapperDivRight = styled.section<WrapperDivRightProps>(
  (
    props: Assign<
      ThemeProps<Theme>,
      {
        sticky?: boolean;
      }
    >,
  ) => `
  background: ${props.theme.colors.goWhite.base};
  box-shadow: ${props.currentHotel ? '10px 0px 16px 0px rgb(210, 210, 210)' : 'inherit'};
  border-bottom: 1px solid ${props.theme.colors.goBrandBlue.light};

`,
);

export const OuterWrapperSection = styled.section<OuterWrapperSectionProps>(
  (
    props: Assign<
      ThemeProps<Theme>,
      {
        backgroundColor?: string;
      }
    >,
  ) => `
  background: ${props.backgroundColor ? props.backgroundColor : props.theme.colors.goWhite.base};
  
  display: flex;
  position: relative;
`,
);

export const SimilarHotelBorder = styled(Column)<SimilarHotelBorderProps>(props => {
  const border = props.currentHotel ? 'none' : `1px solid ${props.theme.colors.goBrandBlue.light}`;
  const cursor = props.currentHotel ? '' : 'pointer';
  return `
    border: ${border};
    border-radius: ${props.theme.misc.borderRadius.base};
    padding: ${props.theme.spacing.custom(8)};
    justify-content: space-between;
    margin-top: ${props.theme.spacing.base};
    :hover {
      border-color: rgb(34, 116, 224);
      cursor: ${cursor};
    }
  `;
});

export const SelectRoomButton = styled(ButtonBase)<SelectRoomButtonProps>`
  ${textSizes.MediumW3}
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : props.theme.colors.goBrandOrange.base};
  padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.base};
  border-radius: ${props => props.theme.misc.borderRadius.base};
`;

export const SimilarHotelPricingWrapper = styled(Column)(
  props => `

  display:flex;
  flex-direction:row;
  justify-content:space-between;
  padding-bottom: ${props.theme.spacing.small};

`,
);

export const SelectButtomOuterWrap = styled(Column)(
  props => `

  display:flex;
  justify-content: flex-end;
  margin-top: ${props.theme.spacing.xxlarge};
`,
);

export const InnerWrapperWidth = styled(Column)(
  props => `

  padding: ${props.theme.spacing.custom(8)};
`,
);

export const SimilarHotelWrapDiv = styled(Column)(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  font-weight: 600;
  font-size:${props.theme.font.custom(16)};
  color:${props.theme.colors.downriver.base};
  padding: 0 ${props.theme.spacing.custom(8)};
`,
);

/**
 * hidden to just have div structure
 * other option could have been to have fixed height
 * for this container
 */
export const SimilarHotelTextHidden = styled.span`
  opacity: 0;
  visibility: hidden;
`;
